
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/memberships",
      function () {
        return require("private-next-pages/memberships.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/memberships"])
      });
    }
  